import { gql, useMutation } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

export const PAY_BILLING_INVOICE_MUTATION = gql`
  mutation PayBillingInvoice($input: BillingPayInvoiceInput!) {
    payBillingInvoice(input: $input) {
      outcome
      paymentError {
        error
        declineCode
        code
        message
        transactionId
      }
      errorDetails
    }
  }
`;

const usePayBillingInvoice = () => {
  const [payBillingInvoice, { loading, error }] = useMutation(PAY_BILLING_INVOICE_MUTATION, { noThrow: true });

  useError(error);

  return { payBillingInvoice, loading, error };
};

export default usePayBillingInvoice;
